/** All built-in and custom scalars, mapped to their actual values */

export let ActiveStatus;
(function (ActiveStatus) {
  ActiveStatus["Active"] = "active";
  ActiveStatus["Inactive"] = "inactive";
})(ActiveStatus || (ActiveStatus = {}));
/** Wrapper for returning available floors for location. Errors only populated if desks are requested but not available. */
/** Wrapper for returning available floors for location. Errors only populated if desks are requested but not available. */
export let BeaconProximity;
(function (BeaconProximity) {
  BeaconProximity["Far"] = "far";
  BeaconProximity["Immediate"] = "immediate";
  BeaconProximity["Near"] = "near";
  BeaconProximity["Unknown"] = "unknown";
})(BeaconProximity || (BeaconProximity = {}));
/** Represents either an Invite, Entry or Delivery */
/**
 * Delivery statuses have the following lifecycle
 *
 * ```
 * new --> processing +--------> pending --> collected
 *                    |             ^
 *                    |             |
 *                    +--> failed --+
 * ```
 *
 * When the deliveries mobile app takes a photo of a label, the client
 * creates a "shell" Delivery with the initial status `new` as a
 * container to upload the label image to. Once the image has been
 * uploaded, it changes status to `processing` while it waits for OCR to
 * complete. Once it receives OCR results, the backend attempts to find
 * a match. If successful, it goes to `pending` state and notifications are
 * sent out. If no match, it transitions to `failed`. Finally, when an
 * employee picks up their package, the delivery transitions to its final
 * resting state, `collected`.
 */
export let DeliveryStatus;
(function (DeliveryStatus) {
  DeliveryStatus["Collected"] = "collected";
  DeliveryStatus["Failed"] = "failed";
  DeliveryStatus["New"] = "new";
  DeliveryStatus["Pending"] = "pending";
  DeliveryStatus["Processing"] = "processing";
})(DeliveryStatus || (DeliveryStatus = {}));
/** Desk availability values */
export let DeskAvailabilityEnum;

/** Desk Status */
(function (DeskAvailabilityEnum) {
  DeskAvailabilityEnum["Available"] = "available";
  DeskAvailabilityEnum["Unavailable"] = "unavailable";
  DeskAvailabilityEnum["UserAssigned"] = "userAssigned";
})(DeskAvailabilityEnum || (DeskAvailabilityEnum = {}));
export let DeskStatusEnum;
(function (DeskStatusEnum) {
  DeskStatusEnum["Anonymous"] = "anonymous";
  DeskStatusEnum["Available"] = "available";
  DeskStatusEnum["Booked"] = "booked";
  DeskStatusEnum["PermanentlyAssigned"] = "permanentlyAssigned";
  DeskStatusEnum["PermanentlyAssignedPrivate"] = "permanentlyAssignedPrivate";
  DeskStatusEnum["Unavailable"] = "unavailable";
})(DeskStatusEnum || (DeskStatusEnum = {}));
/** Direct upload attributes */
/** Wrapper for returning employee desks. Errors only populated if reservation request. */
/** Invite for employee registration only, no visitor invites. */
/** DEPRECATED: Use EmployeeRegistrationPartialDayType instead */
/** Wrapper for multi-day registration and invites data */
/** Available entry scopes are 'mine' or 'boss' */
export let EntryScopeEnum;
(function (EntryScopeEnum) {
  EntryScopeEnum["Boss"] = "boss";
  EntryScopeEnum["Mine"] = "mine";
})(EntryScopeEnum || (EntryScopeEnum = {}));
export let EntryStatusEnum;

/** Wrapper for account configs for various envoy products */
(function (EntryStatusEnum) {
  EntryStatusEnum["SignedIn"] = "signedIn";
  EntryStatusEnum["SignedOut"] = "signedOut";
})(EntryStatusEnum || (EntryStatusEnum = {}));
/** Invite form field */
/** Wrapper for returning reservations matching the given filters */
/** User document input field */
/** User document input field data */
/** User document input field data */
/** User document input field types */
export let InputFieldTypeEnum;
(function (InputFieldTypeEnum) {
  InputFieldTypeEnum["Date"] = "date";
})(InputFieldTypeEnum || (InputFieldTypeEnum = {}));
export let PrivacyPolicyAcceptanceEnum;
(function (PrivacyPolicyAcceptanceEnum) {
  PrivacyPolicyAcceptanceEnum["Accepted"] = "accepted";
  PrivacyPolicyAcceptanceEnum["Expired"] = "expired";
  PrivacyPolicyAcceptanceEnum["NotAccepted"] = "not_accepted";
})(PrivacyPolicyAcceptanceEnum || (PrivacyPolicyAcceptanceEnum = {}));
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** The query root of this schema */
/** A recipient is really just an Employee but with simplified fields */
/** Day to register to come into the office */
/** Valid invite and reservations associated with an office visit on a given day */
/** Room id is usually in the email address format. id is globally unique */
/** Available scopes are 'mine' or 'boss' */
export let ScopeFilterEnum;

/** Represents either an Invite or SelfCertify */
(function (ScopeFilterEnum) {
  ScopeFilterEnum["Boss"] = "boss";
  ScopeFilterEnum["Mine"] = "mine";
})(ScopeFilterEnum || (ScopeFilterEnum = {}));
export let SignInFieldKindEnum;
(function (SignInFieldKindEnum) {
  SignInFieldKindEnum["Email"] = "email";
  SignInFieldKindEnum["Phone"] = "phone";
  SignInFieldKindEnum["SingleSelection"] = "singleSelection";
  SignInFieldKindEnum["Text"] = "text";
})(SignInFieldKindEnum || (SignInFieldKindEnum = {}));
/** Represents either a SimplifiedSignIn or an Invite */
/** Location description source metadata */
/** Location description input data */
/** Ticket location description source_type enum */
export let TicketLocationDescriptionSourceTypeEnum;

/** Ticket priorities */
(function (TicketLocationDescriptionSourceTypeEnum) {
  TicketLocationDescriptionSourceTypeEnum["Deliveries"] = "deliveries";
  TicketLocationDescriptionSourceTypeEnum["Desks"] = "desks";
  TicketLocationDescriptionSourceTypeEnum["Rooms"] = "rooms";
  TicketLocationDescriptionSourceTypeEnum["Text"] = "text";
})(TicketLocationDescriptionSourceTypeEnum || (TicketLocationDescriptionSourceTypeEnum = {}));
export let TicketPriorityEnum;

/** Ticket request type options */
(function (TicketPriorityEnum) {
  TicketPriorityEnum["High"] = "high";
  TicketPriorityEnum["Low"] = "low";
  TicketPriorityEnum["Normal"] = "normal";
  TicketPriorityEnum["Urgent"] = "urgent";
})(TicketPriorityEnum || (TicketPriorityEnum = {}));
export let TicketRequestTypeEnum;

/** An Envoy User */
(function (TicketRequestTypeEnum) {
  TicketRequestTypeEnum["Incident"] = "incident";
  TicketRequestTypeEnum["Problem"] = "problem";
  TicketRequestTypeEnum["Question"] = "question";
  TicketRequestTypeEnum["Request"] = "request";
})(TicketRequestTypeEnum || (TicketRequestTypeEnum = {}));
/** An Envoy User */
/** An Envoy User */
/** An Envoy User */
/** An Envoy User */
/** Represents all the possible user role values including company and location user roles */
export let UserRoleName;
(function (UserRoleName) {
  UserRoleName["Billing"] = "billing";
  UserRoleName["DeliveriesAdmin"] = "deliveries_admin";
  UserRoleName["Employee"] = "employee";
  UserRoleName["GlobalAdmin"] = "global_admin";
  UserRoleName["LocationAdmin"] = "location_admin";
  UserRoleName["Receptionist"] = "receptionist";
  UserRoleName["Security"] = "security";
})(UserRoleName || (UserRoleName = {}));
/**
 * status: a filter by the status – enum of: all, expected, signedIn, signedOut
 * expected = invites
 * signedIn = entries that are currently on-premise
 * signedOut = past entries
 */
export let VisitorSelectionEnum;

/** Represents either an Invite or Entry */
(function (VisitorSelectionEnum) {
  VisitorSelectionEnum["All"] = "all";
  VisitorSelectionEnum["Expected"] = "expected";
  VisitorSelectionEnum["SignedIn"] = "signedIn";
  VisitorSelectionEnum["SignedOut"] = "signedOut";
})(VisitorSelectionEnum || (VisitorSelectionEnum = {}));
/** Wrapper for visitors query and pagination data */
/** Wrapper for workplace-group-members query and pagination data */
/** Workplace Visit Request allows employees to invites other employees to visit a physical space together */
/** Workplace Visit Request create response */
/**
 * The sdl representing the federated service capabilities. Includes federation
 * directives, removes federation types, and includes rest of full schema after
 * schema directives have been applied
 */